import {useMutation} from '@apollo/react-hooks';

import type {
    SetAvailability as SetAvailabilityMutation,
    SetAvailabilityVariables as SetAvailabilityMutationVariables,
    AvailabilitySetInput,
} from 'nutshell-graphql-types';

import SET_AVAILABILITY from '../mutations/set-availability.graphql';

export function useSetAvailability(): (arg1: AvailabilitySetInput) => Promise<any> {
    const [setAvailability] = useMutation<
        SetAvailabilityMutation,
        SetAvailabilityMutationVariables
    >(SET_AVAILABILITY);

    return (input: AvailabilitySetInput) => {
        return setAvailability({
            variables: {input},
        });
    };
}
